import {createSelector} from '@reduxjs/toolkit';
import {selectFeatures, selectJWTEmail, selectUser} from '@components/Login/userSlice';
import {selectConfirmedEmailAliasEmails, selectEmailAliasesUserId} from '@components/AccountSettings/EmailAliases/emailAliasesSlice';
import permissionsService from '@utils/permissionsService';
import {getNormalizedEmail} from '@utils/emailMatching';
import type {RootState} from '@src/client/index';

const NO_ALIAS_EMAILS: string[] = [];

const selectOwnedConfirmedAliasEmails = (state: RootState): string[] => {
    if (!permissionsService.isEmailAliasEnabled({features: selectFeatures(state)})) return NO_ALIAS_EMAILS;
    return selectEmailAliasesUserId(state) === selectUser(state)?.id ? selectConfirmedEmailAliasEmails(state) : NO_ALIAS_EMAILS;
};

export const selectCurrentUserEmails = createSelector(
    [
        (state: RootState) => selectUser(state)?.email,
        (state: RootState) => selectJWTEmail(state),
        selectOwnedConfirmedAliasEmails
    ],
    (primaryEmail, jwtEmail, confirmedAliasEmails): string[] => [
        ...new Set([primaryEmail, jwtEmail, ...confirmedAliasEmails].map(getNormalizedEmail).filter(Boolean))
    ]
);

export const selectIsCurrentUserEmailListReady = (state: RootState): boolean => {
    if (!permissionsService.isEmailAliasEnabled({features: selectFeatures(state)})) return true;
    const userId = selectUser(state)?.id;
    return Boolean(userId) && selectEmailAliasesUserId(state) === userId;
};
